// src/services/orderService.ts
import api from "../../../../../../features/auth/axiosConfig";
import { API_URLS } from "../../../../../../shared/components/Url";
import { OrderData } from "../types/order";

export const fetchOrderById = async (orderId: string): Promise<OrderData> => {
  const { data } = await api.get(`${API_URLS.ORDER}/${orderId}`);
  return data.result as OrderData;
};

export const fetchCustomerLedger = async (customerId: string): Promise<number> => {
  const { data } = await api.get(`/pos/ledger/customer/${customerId}`);
  return data.ledger?.total_outstanding_balance ?? 0;
};

export const updateOrderStatusApi = async (
  orderId: string,
  status: string,
  adjustType: string = "refund"
): Promise<void> => {
  await api.put(`/app/v1/pos/cancel_order?orderid=${orderId}`, {
    OrderStatus: status,
    adjust_type: adjustType,
  });
};
